/** @format */

import { apiInstanceFetch } from "../../../util/api";
import { GET_REFUNDABLE_ORDERS, INITIATE_REFUND, REJECT_REFUND, GET_REFUND_REQUESTS } from "./refund.type";
import { setToast } from "../../../util/toast";

// Get all orders eligible for refund (paymentStatus = 4)
export const getRefundableOrders = (start, limit, startDate, endDate) => (dispatch) => {
	apiInstanceFetch
		.get(`refundRequest/refundableOrders?start=${start}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`)
		.then((res) => {
			if (res.status) {
				dispatch({ type: GET_REFUNDABLE_ORDERS, payload: res });
			}
		})
		.catch((error) => {
			console.log("error", error);
		});
};

// Get refund requests with status filtering
export const getRefundRequests = (start, limit, startDate, endDate, type) => (dispatch) => {
	apiInstanceFetch
		.get(`refundRequest/listRefundRequests?start=${start}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&type=${type}`)
		.then((res) => {
			if (res.status) {
				dispatch({ type: GET_REFUND_REQUESTS, payload: res });
			}
		})
		.catch((error) => {
			console.log("error", error);
		});
};

// Initiate refund (calls Paystack Refund API — refunds to original payment method)
export const initiateRefund = (payload) => (dispatch) => {
	return apiInstanceFetch
		.post(`refundRequest/initiateRefund`, JSON.stringify(payload))
		.then((res) => {
			if (res.status) {
				dispatch({ type: INITIATE_REFUND, payload: payload.orderId });
				setToast("success", res.message || "Refund initiated successfully.");
				return { success: true };
			} else {
				setToast("error", res.message || "Failed to initiate refund.");
				return { success: false };
			}
		})
		.catch((error) => {
			console.log(error);
			setToast("error", "Failed to initiate refund.");
			return { success: false };
		});
};

// Reject/decline a refund
export const rejectRefund = (payload) => (dispatch) => {
	apiInstanceFetch
		.patch(`refundRequest/rejectRefund?orderId=${payload.orderId}&reason=${encodeURIComponent(payload.reason || "")}`)
		.then((res) => {
			if (res.status) {
				dispatch({ type: REJECT_REFUND, payload: payload.orderId });
				setToast("success", "Refund request rejected.");
			} else {
				setToast("error", res.message || "Failed to reject refund.");
			}
		})
		.catch((error) => {
			console.log(error);
			setToast("error", "Failed to reject refund.");
		});
};
